import { FormControlLabel, Typography, Checkbox } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { View } from "../../Base";
import { InfoIcon } from "../../Icons";

const useStyles = makeStyles((theme) => {
  const { pxToRem } = theme.typography;
  return {
    container: {
      marginLeft: "0px",
      marginRight: "auto",
    },
    checkboxLabelContainer: {
      display: "flex",
      alignItems: "center",
      gap: "5px",
      marginLeft: "0px",
    },
    checkboxLabel: {
      fontSize: pxToRem(12),
    },
  };
});

export const WorkScheduleDayCheckbox = ({
  driverEdit,
  name,
  hideInfoIcon,
  disabled,
  message,
  onChange,
}) => {
  const styles = useStyles();
  return (
    <FormControlLabel
      className={styles.container}
      label={
        <View className={styles.checkboxLabelContainer}>
          <Typography className={styles.checkboxLabel}>{message}</Typography>
          {!hideInfoIcon && <InfoIcon fontSize="inherit" />}
        </View>
      }
      disabled={disabled}
      control={
        <Checkbox
          checked={!!driverEdit[name]}
          color={"default"}
          name={name}
          onChange={(e) =>
            onChange({
              ...e,
              target: {
                ...e.target,
                name,
                value: !!e.target.checked,
              },
            })
          }
        />
      }
    />
  );
};
